import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, withXhr } from '@angular/common/http';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

import { ToastrService, ToastrModule } from '@openng/ngx-toastr';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';

import {
  MsalModule,
  MsalService,
  MsalInterceptor,
  MsalGuard,
  MsalBroadcastService
} from '@azure/msal-angular';

import {
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation
} from '@azure/msal-browser';

import { SpinnerInterceptor } from './app/interceptors/spinner.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),

    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
      }),
      MatDialogModule,
      MatNativeDateModule,
      MsalModule.forRoot(
        new PublicClientApplication({
          auth: {
            clientId: environment.clientId,
            authority: environment.authority_URL,
            redirectUri: window.location.origin,
          },
          cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: false,
          }
        }),
        {
          interactionType: InteractionType.Popup,
          authRequest: {
            scopes: ['user.read']
          }
        },
        {
          interactionType: InteractionType.Popup,
          protectedResourceMap: new Map([
            ['https://graph.microsoft.com/v1.0/me', ['User.read']]
          ])
        }
      )
    ),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },

    MsalService,
    MsalBroadcastService,
    MsalGuard
  ]
});
